import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './key-handoff-component-skeleton.scss';

const DETAIL_BOX_COUNT: number = 3;
const KEY_LIST_ROW_COUNT: number = 4;
const SIGNATURE_PANEL_COUNT: number = 2;

const KeyHandoffSkeletonBody = () => (
  <div className="key-handoff-skeleton">
    <div className="keyhand_process_details_row">
      <Row mdCenter>
        {Array.from({ length: DETAIL_BOX_COUNT }, (_, index: number) => (
          <Col xs="12" md="4" key={`detail-box-${index}`}>
            <div className="col_inr">
              <div className="keyhand_process_details_box">
                <Skeleton variant="text" width="7rem" />
                <div className="keyhand_process_details_box_img d-flex align-items-center">
                  <Skeleton variant="circle" width="2.5rem" height="2.5rem" />
                  <Skeleton variant="text" width="60%" />
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>

    <div className="keyhand_process_details_row instructions">
      <Row>
        <Col xs="12" md="6">
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="rect" width="100%" height="4rem" />
        </Col>
        <Col xs="12" md="6">
          <div className="ul_list_box1">
            {Array.from({ length: KEY_LIST_ROW_COUNT }, (_, index: number) => (
              <Skeleton key={`key-list-${index}`} variant="text" width="70%" />
            ))}
          </div>
        </Col>
      </Row>
    </div>

    <div className="row">
      {Array.from({ length: SIGNATURE_PANEL_COUNT }, (_, index: number) => (
        <Col xs="12" md="6" key={`signature-${index}`}>
          <Skeleton variant="text" width="12rem" />
          <Skeleton variant="rect" width="100%" height="8rem" />
        </Col>
      ))}
    </div>
  </div>
);

export default KeyHandoffSkeletonBody;
